export const CUSTOMERS_RESET_STATE = 'CUSTOMERS_RESET_STATE';
export const CUSTOMERS_CURRENT_ITEM = 'CUSTOMERS_CURRENT_ITEM';

export const CUSTOMERS_REQUEST_LOADING = 'CUSTOMERS_REQUEST_LOADING';
export const CUSTOMERS_REQUEST_SUCCESS = 'CUSTOMERS_REQUEST_SUCCESS';
export const CUSTOMERS_REQUEST_FAILED = 'CUSTOMERS_REQUEST_FAILED';

export const CUSTOMERS_CURRENT_ACTION = 'CUSTOMERS_CURRENT_ACTION';
export const CUSTOMERS_RESET_ACTION = 'CUSTOMERS_RESET_ACTION';
